<template>
  <!-- 顶部红色进度条（#e60012） -->
  <div class="real-page-loading" v-show="showLoading">
    <div 
      class="loading-progress" 
      :style="{ width: progress + '%', backgroundColor: '#e60012' }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'RealPageLoading',
  data() {
    return {
      showLoading: false, // 是否显示进度条
      progress: 0, // 当前进度（0-100）
      maxPreProgress: 95, // 预加载最大进度（留5%给最终完成）
      loadingTasks: new Set() // 加载任务池（管理未完成的资源加载）
    };
  },
  methods: {
    // 1. 启动加载（路由跳转时调用）
    startLoading() {
      this.showLoading = true;
      this.progress = 0;
      this.loadingTasks.clear(); // 清空历史任务

      // 监听当前页面的资源加载（图片、JS、CSS等）
      this.listenPageResources();
    },

    // 2. 监听页面资源加载（真实进度来源）
    listenPageResources() {
      // 已加载的资源数量
      let loadedCount = 0;
      // 获取当前页面所有待加载的资源（图片、脚本、样式）
      const allResources = [
        ...document.images, // 图片资源
        ...document.scripts, // 脚本资源
        ...document.styleSheets // 样式资源
      ].filter(res => res.src || res.href); // 过滤有效资源

      const totalResources = allResources.length;
      // 若没有资源，直接跳90%（避免进度条卡住）
      if (totalResources === 0) {
        this.progress = 90;
        return;
      }

      // 为每个资源添加加载监听
      allResources.forEach(resource => {
        const taskKey = resource.src || resource.href;
        this.loadingTasks.add(taskKey); // 加入任务池

        // 资源加载完成/失败的统一处理
        const handleLoad = () => {
          loadedCount++;
          this.loadingTasks.delete(taskKey);
          // 计算资源加载进度（占总进度的60%权重）
          const resourceProgress = (loadedCount / totalResources) * 60;
          // 进度只增不减，且不超过预加载最大值
          this.progress = Math.min(
            Math.max(this.progress, resourceProgress),
            this.maxPreProgress
          );
          // 所有资源加载完，触发完成
          if (this.loadingTasks.size === 0) {
            this.finishLoading();
          }
        };

        // 绑定加载事件（兼容已加载完成的资源）
        if (resource.complete) {
          handleLoad(); // 资源已加载，直接算完成
        } else {
          // resource.addEventListener('load', handleLoad);
          // resource.addEventListener('error', handleLoad); // 失败也算“处理完”
        }
      });
    },

    // 3. 完成加载（路由组件渲染完调用）
    finishLoading() {
      this.progress = 100; // 进度条拉满
      // 延迟隐藏（让用户看到完成动画）
      setTimeout(() => {
        this.showLoading = false;
      }, 300);
    },

    // 4. 强制结束（异常场景备用）
    forceFinish() {
      this.progress = 100;
      this.showLoading = false;
      this.loadingTasks.clear();
    }
  },
  // 组件销毁时清理事件（避免内存泄漏）
  beforeDestroy() {
    const allResources = [...document.images, ...document.scripts, ...document.styleSheets];
    allResources.forEach(resource => {
      resource.removeEventListener('load', this.handleLoad);
      resource.removeEventListener('error', this.handleLoad);
    });
  }
};
</script>

<style scoped>
/* 进度条容器：固定在顶部，全屏宽度 */
.real-page-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px; /* 进度条高度，可调整 */
  z-index: 9999; /* 确保在最顶层 */
  background-color: #f5f5f5; /* 进度条背景色 */
}

/* 进度条本体：过渡动画确保流畅 */
.loading-progress {
  height: 100%;
  transition: width 0.3s ease; /* 进度变化动画 */
}
</style>
